import React, { useEffect } from 'react';
import { useToast } from '@chakra-ui/react'; 
import { NavLink  as RouterLink, useHistory } from 'react-router-dom';
// Chakra imports
import {
	Box,
	Button,
	Checkbox,
	Flex,
	FormControl,
	FormLabel,
	Heading,
	Icon,
	Input,
	InputGroup,
	InputRightElement,
	useColorModeValue,
	Text
} from '@chakra-ui/react';
// Assets
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';

// Custom components
import { HSeparator } from 'components/separator/Separator';
import CenteredAuth from 'layouts/publico/variants/Centered';

import useAuthContext from 'hooks/useAuthContext';

import { PATH_PRIVADO, PATH_HOME } from "const/CommonConst";

function SignIn() {    
	useEffect(() => document.title = `Taurel - Servicios en Línea - Iniciar Sesión`,[]);

	const history = useHistory();

	const {login, isAuthenticate} = useAuthContext();

	if(isAuthenticate)
    {
      history.push(`${PATH_PRIVADO}${PATH_HOME}`);
    }

	const toast = useToast()

	// Chakra color mode
	const textColor = useColorModeValue('navy.700', 'white');
	const textColorSecondary = 'gray.400';
	const textColorDetails = useColorModeValue('navy.700', 'secondaryGray.600');
	const textColorBrand = useColorModeValue('brand.500', 'white');
	const brandStars = useColorModeValue('brand.500', 'brand.400');

	const [ isLoading, setIsLoading ] = React.useState(false);
	const [ user, setUser ] = React.useState('');
	const [ pass, setPass ] = React.useState('');
	const [ show, setShow ] = React.useState(false);

	const handleClick = () => setShow(!show);

	const handlerChangeUser = (e:any) => {
		setUser(e.target.value)
	};

	const handlerChangePass = (e:any) => {
		setPass(e.target.value)
	};

	const handlerClickLogin = async () => {
		try {
			setIsLoading(true);

			const result = await login(user, pass);

			if(result)
			{
				history.push(`${PATH_PRIVADO}${PATH_HOME}`);
			}
			else{
				toast({
					title: 'Error',
					description: 'Usuario o contraseña invalidos.',
					status: 'warning',
					duration: 9000,
					isClosable: true,
				  });
			}
		} 
		catch (error) {
            console.log(error);
          }
		finally{
			setIsLoading(false);
		}		
	};

	return (
		<CenteredAuth
			image={'linear-gradient(135deg, #337ab7 0%, #12518a 100%)'}
			cardTop={{ base: '140px', md: '14vh' }}
			cardBottom={{ base: '50px', lg: 'auto' }}
			mx='0px'>
			<Flex
				maxW={{ base: '100%', md: 'max-content' }}
				w='100%'
				mx={{ base: 'auto', lg: '0px' }}
				me='auto'
				justifyContent='center'
				px={{ base: '20px', md: '0px' }}
				flexDirection='column'>
				<Box me='auto'>
					<Heading color={textColor} fontSize='36px' mb='10px'>
						Iniciar Sesión
					</Heading>
					<Text mb='36px' ms='4px' color={textColorSecondary} fontWeight='400' fontSize='md'>
						¡Ingrese su usuario y contraseña para iniciar sesión!
					</Text>
				</Box>
				<Flex
					zIndex='2'
					direction='column'
					w={{ base: '100%', md: '420px' }}
					maxW='100%'
					background='transparent'
					borderRadius='15px'
					mx={{ base: 'auto', lg: 'unset' }}
					me='auto'
					mb={{ base: '20px', md: 'auto' }}>
					<FormControl>
						<FormLabel display='flex' ms='4px' fontSize='sm' fontWeight='500' color={textColor} mb='8px'>
							Usuario<Text color={brandStars}>*</Text>
						</FormLabel>
						<Input
							isRequired={true}
							variant='auth'
							fontSize='sm'
							value={user}
							onChange={handlerChangeUser}
							ms={{ base: '0px', md: '0px' }}
							type='text'
							mb='24px'
							fontWeight='500'
							size='lg'
						/>
						<FormLabel ms='4px' fontSize='sm' fontWeight='500' color={textColor} display='flex'>
							Contraseña<Text color={brandStars}>*</Text>
						</FormLabel>
						<InputGroup size='md'>
							<Input
								isRequired={true}
								fontSize='sm'
								ms={{ base: '0px', md: '4px' }}
								mb='24px'
								value={pass}
								onChange={handlerChangePass}
								size='lg'
								type={show ? 'text' : 'password'}
								variant='auth'
							/>
							<InputRightElement display='flex' alignItems='center' mt='4px'>
								<Icon
									color={textColorSecondary}
									_hover={{ cursor: 'pointer' }}
									as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
									onClick={handleClick}
								/>
							</InputRightElement>
						</InputGroup>
						<Button fontSize='sm' variant='brand' loadingText='Validando...' isLoading={isLoading} onClick={handlerClickLogin} fontWeight='500' w='100%' h='50' mb='24px'>
							Iniciar Sesión
						</Button>
					</FormControl>
				</Flex>
			</Flex>
		</CenteredAuth>
	);
}

export default SignIn;
